import { Effect, Layer, Schema, type Scope } from "effect";
import { fileEditorTabId } from "../editor-layout-model.ts";
import { QueryWork } from "../state/query-work.ts";
import { EditorRevealRequest, editorRevealFailure, type EditorRevealBindings } from "./reveal-model.ts";
import { EditorRevealIo, EditorReveals } from "./reveal-service.ts";

export const EditorRevealsLive = (root: Scope.Scope) => Layer.effect(EditorReveals, Effect.gen(function* () {
  const io = yield* EditorRevealIo, work = yield* QueryWork;
  const alive = () => root.state._tag !== "Closed";
  return EditorReveals.of({ reveal: Effect.fn("Frontend.EditorReveals.reveal")(function* (input: unknown, bindings: EditorRevealBindings) {
    if (!alive()) return yield* Effect.interrupt;
    const request = yield* Schema.decodeUnknownEffect(EditorRevealRequest)(input).pipe(Effect.mapError(editorRevealFailure));
    const identity = yield* Effect.try({ try: () => {
      const current = bindings.current();
      return { workspaceId: current.workspaceId, scope: current.scope };
    }, catch: editorRevealFailure });
    // Preserve the native synchronous open before yielding the deferred focus.
    yield* Effect.try({ try: () => bindings.openFile(request.file), catch: editorRevealFailure });
    yield* work.observe(Effect.gen(function* () {
      // Monaco installs the new model after React commits the opened file.
      yield* Effect.sleep(80);
      if (!alive()) return yield* Effect.interrupt;
      const current = yield* Effect.try({ try: bindings.current, catch: editorRevealFailure });
      if (current.workspaceId !== identity.workspaceId || current.scope !== identity.scope) return;
      const editor = yield* Effect.try({ try: () => bindings.findEditor(fileEditorTabId(request.file)), catch: editorRevealFailure });
      if (editor) yield* io.apply(editor, request);
    }));
  }) });
}));
